class CartRedirect {
  constructor() {
    this.initRedirect();
  }

  initRedirect() {
    // Redirect from cart page with a 2-second delay
    if (window.location.pathname.includes("/cart")) {
      window.location.href = "/?openCart";
    }
  }
}

new CartRedirect(); // Instantiate the CartRedirect class on page load
